import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PurchaseOrder } from '~v2Models/purchaseOrders.model';

@Component({
  selector: 'sa-lmo-closed-purchase-orders-table',
  styleUrls: ['./lmo-closed-purchase-orders-table.component.scss'],
  templateUrl: './lmo-closed-purchase-orders-table.component.html',
})
export class LmoClosedPurchaseOrdersTableComponent implements OnInit {
  public activeDataSource: MatTableDataSource<PurchaseOrder>;
  public displayedColumns = ['name', 'mineName', 'meshType', 'costPerTon', 'totalAllocationUsed'];
  @ViewChild(MatSort, { static: true }) public sort: MatSort;

  @Input() public set closedPurchaseOrders(value: PurchaseOrder[]) {
    if (value) {
      this.activeDataSource.data = value;
    } else {
      this.activeDataSource.data = [];
    }
  }

  constructor() {
    this.activeDataSource = new MatTableDataSource([]);
  }

  public ngOnInit(): void {
    this.activeDataSource.sort = this.sort;
  }
}
